// extracted by mini-css-extract-plugin
export default {"kpi_coming_soon":"KPIComingSoon_kpi_coming_soon__acbnL","kpi_icon":"KPIComingSoon_kpi_icon__63Wzq","kpi_text":"KPIComingSoon_kpi_text__8xU9E"};